"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInvalid = exports.StyledButton = exports.InputWrapper = exports.QRButton = exports.Subtitle = exports.StyledInput = exports.ContentWrapper = void 0;
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const styled_components_1 = __importStar(require("styled-components"));
exports.ContentWrapper = styled_components_1.default.div `
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
exports.StyledInput = styled_components_1.default.input `
  ${({ error }) => (0, styled_components_1.css) `
    background: #f1f7fd;
    border: ${error ? "1px solid red" : "1px solid #d4d9e8"};
    border-radius: 12px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #8792a8;
    padding: 16px;
    padding-right: 48px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    text-overflow: ellipsis;
  `}
`;
exports.Subtitle = styled_components_1.default.div `
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #3e4555;
  text-align: left;
`;
exports.QRButton = styled_components_1.default.button `
  ${({ arrow }) => (0, styled_components_1.css) `
    display: flex;
    justify-content: center;
    align-items: center;
    color: #2793ff;
    outline: none;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 56px;
    padding-right: 12px;
    border-radius: 0 12px 12px 0;
    border: none;
    cursor: pointer;
    background: ${arrow ? "#2793ff" : "none"};
    &:disabled {
      border-top: 1px solid red;
      border-right: 1px solid red;
      border-bottom: 1px solid red;
      background: #c8cdd8;
    }
  `}
`;
exports.InputWrapper = styled_components_1.default.div `
  position: relative;
  margin-top: 16px;
`;
exports.StyledButton = styled_components_1.default.button `
  background: #0085ff;
  box-shadow: 0px 12px 54px rgba(13, 31, 49, 0.0589215);
  border: none;
  border-radius: 12px;
  font-weight: 700;
  font-size: 16px;
  line-height: 14px;
  color: #ffffff;
  padding: 13px 19px;
  cursor: pointer;
`;
exports.StyledInvalid = styled_components_1.default.div `
  color: ${bitcoincom_pkg_theme_1.colors.solid.primaryRed};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  width: 100%;
  margin-top: 8px;
`;
//# sourceMappingURL=styled.js.map